module.exports = __webpack_public_path__ + "images/category_lp/brand/new/store_images/5_7383cb7c9523790815b6dc01a800cfa2.png";